// Header.js

import React from 'react';

function Header() {
    return <header>
            <h1>Dela's Den</h1>
        </header>;
}

export default Header;